import React from "react";
import BaseEdge, { roundedOrthPath, roundTo } from "./BaseEdge";

// Multi-segment (Manhattan-style) polyline edge.
// Supports dragging via edgeControls just like orthogonal edges.
export default function PolylineEdge({
  edge,
  nodeById,
  edgeIndex,
  selectedIndex,
  onSelectEdge,
  onStartEdgeDrag,
  edgeControls,
  color,
}) {
  const from = nodeById[edge.from];
  const to = nodeById[edge.to];
  if (!from || !to) return null;

  const src = {
    x: roundTo(from.x + from.width / 2),
    y: roundTo(from.y + from.height / 2),
  };

  const dst = {
    x: roundTo(to.x + to.width / 2),
    y: roundTo(to.y + to.height / 2),
  };

  const ctrl = edgeControls?.[edgeIndex];

  // Default S-like Manhattan path
  const midX = (src.x + dst.x) / 2;

  const p1 = ctrl?.p1 ?? { x: Math.round(midX), y: src.y };
  const p2 = ctrl?.p2 ?? { x: Math.round(midX), y: dst.y };

  const pts = [src, p1, p2, dst];
  const d = roundedOrthPath(pts);

  const labelPos = {
    x: (p1.x + p2.x) / 2,
    y: (p1.y + p2.y) / 2 - 12,
  };

  return (
    <BaseEdge
      d={d}
      stroke={color}
      onSelect={() => onSelectEdge(edgeIndex)}
      onStartDrag={(e) =>
        onStartEdgeDrag(edgeIndex, {
          clientX: e.clientX,
          clientY: e.clientY,
        })
      }
      label={edge.label}
      labelPos={labelPos}
    />
  );
}
